import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Container = styled(Link)`
  position: absolute;
  right: 1.5rem;
  bottom: 0.5rem;
  z-index: 999999999999;

  background: ${({ theme }) => theme.colors.red};
  padding: 0.5rem;
  border-radius: 5px;

  display: flex;
  align-items: center;

  transition: background 0.3s;

  /* &:hover {
    background: ;
  } */

  span:first-child {
    margin-right: 0.25rem;
    font-weight: 500;
    font-size: 1rem;
  }

  svg {
    fill: ${({ theme }) => theme.colors.white};
    width: 1.75rem;
    height: 1.75rem;
  }

  span:last-child {
    margin-left: 0.75rem;
    font-weight: 500;
    font-size: 1.5rem;
    color: ${({ theme }) => theme.colors.yellow};
  }

  @media (max-width: 720px) {
    top: 0.5rem;
    bottom: initial;

    span: first-child {
      display: none;
    }
  }
`
